import { lazy } from 'react';
import { NoContentPage } from '../components/shared';

const AsyncLanding = lazy(() => import('../containers/shared/landing'));

// programme / portfolio / interventions
const AsyncProgramme = lazy(() => import('../containers/shared/programmes'));
const AsyncProgrammeOverview = lazy(() => import('../containers/shared/programmes/overview'));
const AsyncProgrammeIndicators = lazy(() => import('../containers/shared/programmes/indicators'));
const AsyncProgrammeMonitoring = lazy(() => import('../containers/shared/programmes/monitoring'));
const AsyncProgrammeComplete = lazy(() => import('../containers/shared/programmes/summary'));
const AsyncProgrammeSites = lazy(() => import('../containers/shared/programmes/sites'));
const AsyncProgrammeHierarchies = lazy(() => import('../containers/shared/programmes/sites/hierarchies'));
const AsyncProgrammeHierarchy = lazy(() => import('../containers/shared/programmes/sites/hierarchies/hierarchy'));
const AsyncProgrammeServices = lazy(() => import('../containers/shared/programmes/sites/services'));
const AsyncProgrammeService = lazy(() => import('../containers/shared/programmes/sites/services/service'));
const AsyncProgrammeReporters = lazy(() => import('../containers/shared/programmes/reporters'));
const AsyncProgrammeReporterAssignees = lazy(() => import('../containers/shared/programmes/reporters/assignees'));
const AsyncInterventionOverview = lazy(() => import('../containers/shared/interventions/overview'));
const AsyncInterventionIndicators = lazy(() => import('../containers/shared/interventions/indicators'));
const AsyncInterventionInputs = lazy(() => import('../containers/shared/interventions/inputs'));
const AsyncInterventionActivities = lazy(() => import('../containers/shared/interventions/activities'));
const AsyncInterventionMonitoring = lazy(() => import('../containers/shared/interventions/monitoring'));
const AsyncInterventionComplete = lazy(() => import('../containers/shared/interventions/complete'));
const AsyncInterventionStakeholderCohorts = lazy(() => import('../containers/shared/interventions/stakeholders'));
const AsyncInterventionStakeholders = lazy(() => import('../containers/shared/interventions/stakeholders'));
const AsyncInterventionStakeholderCohortDetails = lazy(() =>
  import('../containers/shared/interventions/stakeholders/CohortDetails')
);
const AsyncInterventionInstitutionCohorts = lazy(() => import('../containers/shared/interventions/institutions'));
const AsyncInterventionInstitutions = lazy(() => import('../containers/shared/interventions/institutions'));
const AsyncInterventionInstitutionCohortDetails = lazy(() =>
  import('../containers/shared/interventions/institutions/CohortDetails')
);

// manage people
const AsyncPeople = lazy(() => import('../containers/shared/peopleProfiles'));
const AsyncPeopleProfileDetails = lazy(() => import('../containers/shared/peopleProfiles/forms/PersonDetails'));
const AsyncAddPeopleTable = lazy(() => import('../containers/shared/peopleProfiles/forms/PersonDetails'));
const AsyncPeopleCohorts = lazy(() => import('../containers/shared/peopleProfiles'));
const AsyncPeopleCohortDetails = lazy(() => import('../containers/shared/peopleProfiles/CohortDetails'));

// data export
const AsyncMetabaseDataExport = lazy(() => import('../containers/shared/export'));
const AsyncMetabaseDataExportQuestion = lazy(() => import('../containers/shared/export/Question'));
const AsyncExport = lazy(() => import('../containers/funder/export/AttributeExportDashboard'));
const AsyncProgrammeStats = lazy(() => import('../containers/funder/export/ProgrammeStatsDashboard'));

// reports
const AsyncReports = lazy(() => import('../containers/shared/reports'));
const AsyncReportDetails = lazy(() => import('../containers/shared/reports/Details'));

const AllFunderTemplates = lazy(() => import('../containers/funder/templates/AllFunderTemplates'));
const AsyncFunderTemplateDetails = lazy(() => import('../containers/funder/templates/template'));

const AsyncTeamMembers = lazy(() => import('../containers/funder/TeamMembers'));
const AsyncTeamMembersCreate = lazy(() => import('../containers/funder/TeamMembers/forms/CreateForm'));

const AsyncServiceProviders = lazy(() => import('../containers/funder/ServiceProviders'));
const AsyncGrants = lazy(() => import('../containers/funder/grants'));
const AsyncServiceProvidersCreate = lazy(() => import('../containers/funder/ServiceProviders/forms/CreateForm'));

const AsyncProfile = lazy(() => import('../containers/shared/profile'));
// Insights
const AsyncManageInsights = lazy(() => import('../containers/funder/Insights'));
const AsyncInsightsDetails = lazy(() => import('../containers/funder/Insights/forms/Details'));
const AsyncInsights = lazy(() => import('../containers/shared/insights/AllInsights'));
const AsyncInsightsEmbedFrame = lazy(() => import('../containers/shared/insights/InsightsEmbedReport'));

// admin
const AsyncAdminPage = lazy(() => import('../containers/shared/admin'));
const AsyncAccountDetails = lazy(() => import('../containers/funder/account'));
const AsyncAdminWorkspaceCreate = lazy(() => import('../containers/funder/admin/workspace/CreateForm'));
const AsyncAdminWorkspaceOverview = lazy(() => import('../containers/shared/admin/overview'));
const AsyncAdminWorkspaceDatasetCreate = lazy(() => import('../containers/shared/admin/datasets/Dataset'));
const AsyncAdminWorkspaceFormCreate = lazy(() => import('../containers/shared/admin/forms/CreateForm'));
const AsyncAdminModules = lazy(() => import('../containers/shared/admin/modules'));
const AsyncAdminAuditTrail = lazy(() => import('../containers/shared/admin/auditTrail'));
const AllWorkspaces = lazy(() => import('../containers/funder/admin/workspace'));
const AsyncAdminOrganisations = lazy(() => import('../containers/shared/admin/organisations'));
const AsyncAdminOrganisationsUsers = lazy(() => import('../containers/shared/admin/organisations/users'));

// institutions

const AsyncInstitutions = lazy(() => import('../containers/shared/institutions'));
const AsyncInstitutionDetails = lazy(() => import('../containers/shared/institutions/InstitutionDetails'));
const AsyncInstitutionCohorts = lazy(() => import('../containers/shared/institutions'));
const AsyncInstitutionCohortDetails = lazy(() => import('../containers/shared/institutions/CohortDetails'));
const AsyncInstitutionRegistrations = lazy(() => import('../containers/shared/institutions'));
const AsyncArchivedInstitutions = lazy(() => import('../containers/institution/institutions/AllArchivedInstitutions'));
const AsyncECDServiceDetails = lazy(() => import('../containers/institution/institutions/ECDService/Details'));
const AsyncECDServiceContacts = lazy(() => import('../containers/institution/institutions/ECDService/Contacts'));
const AsyncECDServiceRegistrationManagement = lazy(() =>
  import('../containers/institution/institutions/ECDService/Registration')
);
const AsyncECDRegistrations = lazy(() => import('../containers/institution/institutions/AllEcds'));
const AsyncECDApplication = lazy(() => import('../containers/institution/institutions/ecdRegistration/application'));
const AsyncECDFramework = lazy(() => import('../containers/institution/institutions/ecdRegistration/framework'));
const AsyncECDApproval = lazy(() => import('../containers/institution/institutions/ecdRegistration/approval'));
const AsyncECDAssessment = lazy(() => import('../containers/institution/institutions/ecdRegistration/assessment'));
const AsyncECDComplete = lazy(() => import('../containers/institution/institutions/ecdRegistration/complete'));

// My activities
const AsyncActivitiesDetails = lazy(() => import('../containers/shared/activities/ActivitiesDetails'));
const AsyncActivitiesAttendees = lazy(() => import('../containers/shared/activities/forms/ActivityAttendeesForm'));
const AsyncActivitiesSessions = lazy(() => import('../containers/shared/sessions'));
const AsyncActivitiesSessionsCreate = lazy(() => import('../containers/shared/sessions/forms/CreateForm'));
const AsyncManageActivitiesDetails = lazy(() => import('../containers/shared/activities/ManageActivitiesDetails'));
const AsyncManageGroupOptions = lazy(() => import('../containers/shared/activities/groups/options'));
const AsyncActivityForm = lazy(() => import('../containers/shared/activities/forms/ActivityForm'));
const AsyncActivityAssignUsers = lazy(() => import('../containers/shared/activities/forms/ActivityAssignUsers'));

// Indicators
const AsyncIndicatorFrameworks = lazy(() => import('../containers/shared/indicatorFrameworks'));
const AsyncIndicators = lazy(() => import('../containers/shared/indicatorFrameworks/pages'));
const AsyncIndicatorPeriods = lazy(() => import('../containers/shared/indicatorFrameworks/pages/IndicatorPeriods'));
const AsyncIndicatorFrameworkMonitoring = lazy(() => import('../containers/shared/indicatorFrameworks/monitoring'));
const AsyncIndicatorFrameworkReporters = lazy(() => import('../containers/shared/programmes/reporters'));
const AsyncIndicatorFrameworkReportersAssignees = lazy(() =>
  import('../containers/shared/programmes/reporters/assignees')
);
// My Forms
const AsyncMyFormsPage = lazy(() => import('../containers/shared/myForms'));
const AsyncMyFormsSubmissionPage = lazy(() => import('../containers/shared/myForms/submissions/CreateForm'));
const AsyncMyFormsCreateSubmission = lazy(() => import('../containers/shared/myForms/submissions/CreateSubmission'));
const AsyncMyFormsSubmissionCalculate = lazy(() => import('../containers/shared/myForms/submissions/Calculate'));

// Notifications
const AsyncNotifications = lazy(() => import('../containers/shared/notifications'));

// Dashboard
const AsyncDashboards = lazy(() => import('../containers/shared/dashboard'));
const AsyncReportingRequirements = lazy(() => import('../containers/shared/reportingRequirements'));
const AsyncReportingRequirementDetail = lazy(() =>
  import('../containers/shared/reportingRequirements/RequirementDetail')
);
const AsyncDashboardsDashboard = lazy(() => import('../containers/shared/dashboard/Dashboard'));
const AsyncDashboardsUsers = lazy(() => import('../containers/shared/dashboard/DashboardUsers'));
const AsyncInsightUsers = lazy(() => import('../containers/shared/insights/InsightUsers'));
const AsyncDashboardsMetabase = lazy(() => import('../containers/shared/dashboard/Metabase'));
const AsyncNewDashboardLayout = lazy(() => import('../containers/shared/dashboard/newDashboardLayout'));

const AsyncIndicatorFrameworkPeriodGroups = lazy(() => import('../containers/shared/periodGroups'));
const AsyncIndicatorFrameworkPeriodGroupPeriods = lazy(() =>
  import('../containers/shared/periodGroups/IndicatorPeriods')
);
const AsyncIndicatorFrameworkCurrencyGroupPeriods = lazy(() =>
  import('../containers/shared/currencyGroups/IndicatorPeriods')
);
const AsyncIndicatorFrameworkCurrencyGroups = lazy(() => import('../containers/shared/currencyGroups'));

// My Cases
const AsyncMyCases = lazy(() => import('../containers/shared/cases'));
const AsyncClientPage = lazy(() => import('../containers/shared/cases/ClientPage'));
const AsyncConsultationPage = lazy(() => import('../containers/shared/cases/ConsultationPage'));
const AsyncCaseManagement = lazy(() => import('../containers/shared/cases/CaseManagement'));
const AsyncConfigureSession = lazy(() => import('../containers/shared/cases/ConfigureSession'));
export const funderRoutes = [
  // IB-1897: Grants handles its own tabs and grant pages below this path
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Grants', path: '/funder/manage/grants' },
    ],
    exact: false,
    path: '/funder/manage/grants',
    component: AsyncGrants,
  },
  {
    breadcrumbs: [{ title: 'Home', path: '/funder' }],
    exact: true,
    path: '/funder',
    component: AsyncLanding,
  },
  {
    breadcrumbs: [{ title: 'Home', path: '/funder/insights' }],
    exact: true,
    path: '/funder/insights',
    component: AsyncInsights,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Insights', path: '/funder/insights' },
    ],
    exact: true,
    path: '/funder/insights/:insightType/:insightId',
    component: AsyncInsightsEmbedFrame,
  },
  {
    breadcrumbs: [{ title: 'Home', path: '/funder/my-profile' }],
    exact: true,
    path: '/funder/my-profile',
    component: AsyncProfile,
  },

  // manage people
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'People', path: '/funder/manage/people' },
    ],
    exact: true,
    path: '/funder/manage/people',
    component: AsyncPeople,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'People', path: '/funder/manage/people' },
      { title: 'Cohorts', path: '/funder/manage/people/cohorts' },
    ],
    exact: true,
    path: '/funder/manage/people/cohorts',
    component: AsyncPeopleCohorts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'People', path: '/funder/manage/people' },
      { title: 'Create', path: '/funder/manage/people/create' },
    ],
    exact: true,
    path: '/funder/manage/people/create',
    component: AsyncPeopleProfileDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'People', path: '/funder/manage/people' },
      { title: 'Add New', path: '/funder/manage/people/addnew' },
    ],
    exact: true,
    path: '/funder/manage/people/addnew',
    component: AsyncAddPeopleTable,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'People', path: '/funder/manage/people' },
      { title: 'Edit', path: '/funder/manage/people/:personId' },
    ],
    exact: true,
    path: '/funder/manage/people/:personId',
    component: AsyncPeopleProfileDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'People', path: '/funder/manage/people' },
      { title: 'Cohorts', path: '/funder/manage/people/cohorts' },
      { title: 'Create', path: '/funder/manage/people/cohorts/create' },
    ],
    exact: true,
    path: '/funder/manage/people/cohorts/create',
    component: AsyncPeopleCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'People', path: '/funder/manage/people' },
      { title: 'Cohorts', path: '/funder/manage/people/cohorts' },
      { title: 'Edit', path: '/funder/manage/people/cohorts/:cohortId' },
    ],
    exact: true,
    path: '/funder/manage/people/cohorts/:cohortId',
    component: AsyncPeopleCohortDetails,
  },

  // manage activities
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'My Activities', path: '/funder/manage/activities' },
    ],
    exact: true,
    path: '/funder/manage/activities',
    component: AsyncManageActivitiesDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Groups', path: '/funder/manage/groups' },
    ],
    exact: true,
    path: '/funder/manage/groups',
    component: AsyncManageActivitiesDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Groups', path: '/funder/manage/groups' },
      { title: 'Options', path: '/funder/manage/groups/:groupId/options' },
    ],
    exact: true,
    path: '/funder/manage/groups/:groupId/options',
    component: AsyncManageGroupOptions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Services', path: '/funder/manage/services' },
    ],
    exact: true,
    path: '/funder/manage/services',
    component: AsyncManageActivitiesDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/manage/activities' },
      { title: 'Attendees', path: '/funder/manage/activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/funder/manage/activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/manage/activities' },
      { title: 'Attendees', path: '/funder/manage/activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/funder/manage/activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/manage/activities' },
      { title: 'Sessions', path: '/funder/manage/activities/:activityId/sessions/' },
    ],
    exact: true,
    path: '/funder/manage/activities/:activityId/sessions/',
    component: AsyncManageActivitiesDetails,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/manage/activities' },
      { title: 'Sessions', path: '/funder/manage/activities/:activityId/sessions/' },
      { title: 'Create Session', path: '/funder/manage/activities/:activityId/sessions/create' },
    ],
    exact: true,
    path: '/funder/manage/activities/:activityId/sessions/create',
    component: AsyncActivitiesSessionsCreate,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/manage/activities' },
      { title: 'Sessions', path: '/funder/manage/activities/:activityId/sessions/' },
      { title: 'Update Session', path: '/funder/manage/activities/:activityId/sessions/:sessionId' },
    ],
    exact: true,
    path: '/funder/manage/activities/:activityId/sessions/:sessionId',
    component: AsyncActivitiesSessionsCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/manage/activities' },
      { title: 'Activity', path: '/funder/manage/activities/activity/:activityId' },
    ],
    exact: true,
    path: '/funder/manage/activities/activity/:activityId',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/manage/activities' },
      { title: 'Create', path: '/funder/manage/activities/create' },
    ],
    exact: true,
    path: '/funder/manage/activities/create',
    component: AsyncActivityForm,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/manage/activities' },
      { title: 'Edit', path: '/funder/manage/activities/:activityId' },
    ],
    exact: true,
    path: '/funder/manage/activities/:activityId',
    component: AsyncActivityForm,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/manage/activities' },
      { title: 'Assign Users', path: '/funder/manage/activities/:activityId/assign-users' },
    ],
    exact: true,
    path: '/funder/manage/activities/:activityId/assign-users',
    component: AsyncActivityAssignUsers,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'IndicatorFrameworks', path: '/funder/manage/indicatorFrameworks' },
    ],
    exact: true,
    path: '/funder/manage/indicatorFrameworks',
    component: AsyncIndicatorFrameworks,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'IndicatorFrameworks', path: '/funder/manage/indicatorFrameworks' },
      {
        title: 'Indicators',
        path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
      },
    ],
    exact: true,
    path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
    component: AsyncIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'IndicatorFrameworks', path: '/funder/manage/indicatorFrameworks' },
      {
        title: 'Indicators',
        path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
      },
      {
        title: 'Edit',
        path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId',
      },
    ],
    exact: true,
    path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId',
    component: AsyncIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'IndicatorFrameworks', path: '/funder/manage/indicatorFrameworks' },
      {
        title: 'Indicators',
        path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
      },
      {
        title: 'Periods',
        path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId/periods',
      },
    ],
    exact: true,
    path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId/periods',
    component: AsyncIndicatorPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'IndicatorFrameworks', path: '/funder/manage/indicatorFrameworks' },
      {
        title: 'Monitoring',
        path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/monitoring',
      },
    ],
    exact: true,
    path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/monitoring',
    component: AsyncIndicatorFrameworkMonitoring,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'IndicatorFrameworks', path: '/funder/manage/indicatorFrameworks' },
      { title: 'Reporters', path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/reporters' },
    ],
    exact: true,
    path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/reporters',
    component: AsyncIndicatorFrameworkReporters,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'IndicatorFrameworks', path: '/funder/manage/indicatorFrameworks' },
      { title: 'Reporters', path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/reporters' },
      {
        title: 'Assignees',
        path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/reporters/:reporterId/assignees',
      },
    ],
    exact: true,
    path: '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/reporters/:reporterId/assignees',
    component: AsyncIndicatorFrameworkReportersAssignees,
  },
  // manage service providers
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Service Providers', path: '/funder/manage/service-providers' },
    ],
    exact: true,
    path: '/funder/manage/service-providers',
    component: AsyncServiceProviders,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Service Providers', path: '/funder/manage/service-providers' },
      { title: 'Create', path: '/funder/manage/service-providers/create-new' },
    ],
    exact: true,
    path: '/funder/manage/service-providers/create-new',
    component: AsyncServiceProvidersCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Service Providers', path: '/funder/manage/service-providers' },
      { title: 'Edit', path: '/funder/manage/service-providers/:serviceProviderId' },
    ],
    exact: true,
    path: '/funder/manage/service-providers/:serviceProviderId',
    component: AsyncServiceProvidersCreate,
  },

  // manage programmes
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
    ],
    exact: true,
    path: '/funder/programmes',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Portfolios', path: '/funder/programmes/portfolios', key: 'Portfolios-tab' },
    ],
    exact: true,
    path: '/funder/programmes/portfolios',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes', key: 'Programmes-tab' },
    ],
    exact: true,
    path: '/funder/programmes',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Create', path: '/funder/programmes/create' },
    ],
    exact: true,
    path: '/funder/programmes/create',
    component: AsyncProgrammeOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Overview', path: '/funder/programmes/:programmeId/overview' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/overview',
    component: AsyncProgrammeOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Indicators', path: '/funder/programmes/:programmeId/indicators' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/indicators',
    component: AsyncProgrammeIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Monitoring', path: '/funder/programmes/:programmeId/monitoring' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/monitoring',
    component: AsyncProgrammeMonitoring,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Complete', path: '/funder/programmes/:programmeId/complete' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/complete',
    component: AsyncProgrammeComplete,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Sites', path: '/funder/programmes/:programmeId/sites' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/sites',
    component: AsyncProgrammeSites,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Sites', path: '/funder/programmes/:programmeId/sites' },
      { title: 'Hierarchies', path: '/funder/programmes/:programmeId/sites/hierarchies' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/sites/hierarchies',
    component: AsyncProgrammeHierarchies,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Sites', path: '/funder/programmes/:programmeId/sites' },
      { title: 'Hierarchies', path: '/funder/programmes/:programmeId/sites/hierarchies' },
      { title: 'Hierarchy', path: '/funder/programmes/:programmeId/sites/hierarchies/:hierarchyId' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/sites/hierarchies/:hierarchyId',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Sites', path: '/funder/programmes/:programmeId/sites' },
      { title: 'Hierarchies', path: '/funder/programmes/:programmeId/sites/hierarchies' },
      { title: 'Create', path: '/funder/programmes/:programmeId/sites/hierarchies/create' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/sites/hierarchies/create',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Sites', path: '/funder/programmes/:programmeId/sites' },
      { title: 'Services', path: '/funder/programmes/:programmeId/sites/services' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/sites/services',
    component: AsyncProgrammeServices,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Sites', path: '/funder/programmes/:programmeId/sites' },
      { title: 'Services', path: '/funder/programmes/:programmeId/sites/services' },
      { title: 'Service', path: '/funder/programmes/:programmeId/sites/services/:serviceId' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/sites/services/:serviceId',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Sites', path: '/funder/programmes/:programmeId/sites' },
      { title: 'Services', path: '/funder/programmes/:programmeId/sites/services' },
      { title: 'Create', path: '/funder/programmes/:programmeId/sites/services/create' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/sites/services/create',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Reporters', path: '/funder/programmes/:programmeId/reporters' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/reporters',
    component: AsyncProgrammeReporters,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Reporters', path: '/funder/programmes/:programmeId/reporters' },
      { title: 'Assignees', path: '/funder/programmes/:programmeId/reporters/:reporterId/assignees' },
    ],
    exact: true,
    path: '/funder/programmes/:programmeId/reporters/:reporterId/assignees',
    component: AsyncProgrammeReporterAssignees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
    ],
    exact: true,
    path: '/funder/programmes/interventions',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Create', path: '/funder/programmes/interventions/create' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/create',
    component: AsyncInterventionOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Overview', path: '/funder/programmes/interventions/:interventionId/overview' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/overview',
    component: AsyncInterventionOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Inputs', path: '/funder/programmes/interventions/:interventionId/inputs' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/inputs',
    component: AsyncInterventionInputs,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Indicators', path: '/funder/programmes/interventions/:interventionId/indicators' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/indicators',
    component: AsyncInterventionIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Activities', path: '/funder/programmes/interventions/:interventionId/activities' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/activities',
    component: AsyncInterventionActivities,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Monitoring', path: '/funder/programmes/interventions/:interventionId/monitoring' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/monitoring',
    component: AsyncInterventionMonitoring,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Complete', path: '/funder/programmes/interventions/:interventionId/complete' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/complete',
    component: AsyncInterventionComplete,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Stakeholders', path: '/funder/programmes/interventions/:interventionId/stakeholders' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/stakeholders',
    component: AsyncInterventionStakeholders,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Stakeholders', path: '/funder/programmes/interventions/:interventionId/stakeholders' },
      { title: 'Cohorts', path: '/funder/programmes/interventions/:interventionId/stakeholders/cohorts' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/stakeholders/cohorts',
    component: AsyncInterventionStakeholderCohorts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Stakeholders', path: '/funder/programmes/interventions/:interventionId/stakeholders' },
      { title: 'Cohorts', path: '/funder/programmes/interventions/:interventionId/stakeholders/cohorts' },
      {
        title: 'Create',
        path: '/funder/programmes/interventions/:interventionId/stakeholders/cohorts/create',
      },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/stakeholders/cohorts/create',
    component: AsyncInterventionStakeholderCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Stakeholders', path: '/funder/programmes/interventions/:interventionId/stakeholders' },
      { title: 'Cohorts', path: '/funder/programmes/interventions/:interventionId/stakeholders/cohorts' },
      {
        title: 'Create',
        path: '/funder/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId',
      },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId',
    component: AsyncInterventionStakeholderCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Institutions', path: '/funder/programmes/interventions/:interventionId/institutions' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/institutions',
    component: AsyncInterventionInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Institutions', path: '/funder/programmes/interventions/:interventionId/institutions' },
      { title: 'Cohorts', path: '/funder/programmes/interventions/:interventionId/institutions/cohorts' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/institutions/cohorts',
    component: AsyncInterventionInstitutionCohorts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Institutions', path: '/funder/programmes/interventions/:interventionId/institutions' },
      { title: 'Cohorts', path: '/funder/programmes/interventions/:interventionId/institutions/cohorts' },
      {
        title: 'Create',
        path: '/funder/programmes/interventions/:interventionId/institutions/cohorts/create',
      },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/institutions/cohorts/create',
    component: AsyncInterventionInstitutionCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Institutions', path: '/funder/programmes/interventions/:interventionId/institutions' },
      { title: 'Cohorts', path: '/funder/programmes/interventions/:interventionId/institutions/cohorts' },
      {
        title: 'Create',
        path: '/funder/programmes/interventions/:interventionId/institutions/cohorts/:cohortId',
      },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/institutions/cohorts/:cohortId',
    component: AsyncInterventionInstitutionCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Reporters', path: '/funder/programmes/interventions/:interventionId/reporters' },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/reporters',
    component: AsyncProgrammeReporters,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'Interventions', path: '/funder/programmes/interventions' },
      { title: 'Reporters', path: '/funder/programmes/interventions/:interventionId/reporters' },
      {
        title: 'Assignees',
        path: '/funder/programmes/interventions/:interventionId/reporters/:reporterId/assignees',
      },
    ],
    exact: true,
    path: '/funder/programmes/interventions/:interventionId/reporters/:reporterId/assignees',
    component: AsyncProgrammeReporterAssignees,
  },

  // manage templates
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Templates', path: '/funder/manage/templates' },
    ],
    exact: true,
    path: '/funder/manage/templates',
    component: AllFunderTemplates,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Templates', path: '/funder/manage/templates' },
      { title: 'Create', path: '/funder/manage/templates/create-new' },
    ],
    exact: true,
    path: '/funder/manage/templates/create-new',
    component: AsyncFunderTemplateDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Templates', path: '/funder/manage/templates' },
      { title: 'Edit', path: '/funder/manage/templates/:templateId' },
    ],
    exact: true,
    path: '/funder/manage/templates/:templateId',
    component: AsyncFunderTemplateDetails,
  },

  // team members
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Team Members', path: '/funder/team-members' },
    ],
    exact: true,
    path: '/funder/team-members',
    component: AsyncTeamMembers,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Team Members', path: '/funder/team-members' },
      { title: 'Create', path: '/funder/team-members/create-new' },
    ],
    exact: true,
    path: '/funder/team-members/create-new',
    component: AsyncTeamMembersCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Team Members', path: '/funder/team-members' },
      { title: 'Edit', path: '/funder/team-members/:teamMemberId' },
    ],
    exact: true,
    path: '/funder/team-members/:teamMemberId',
    component: AsyncTeamMembersCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Team Members', path: '/funder/team-members' },
    ],
    exact: true,
    path: '/funder/team-members',
    component: NoContentPage,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'IndicatorFrameworks', path: '/funder/manage/indicatorFrameworks' },
      { title: 'PeriodGroups', path: '/funder/manage/indicatorFrameworks/period-groups' },
    ],
    exact: true,
    path: '/funder/manage/indicatorFrameworks/period-groups',
    component: AsyncIndicatorFrameworkPeriodGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'IndicatorFrameworks', path: '/funder/manage/indicatorFrameworks' },
      { title: 'PeriodGroups', path: '/funder/manage/indicatorFrameworks/period-groups' },
      {
        title: 'Periods',
        path: '/funder/manage/indicatorFrameworks/period-groups/:periodGroupId/periods',
      },
    ],
    exact: true,
    path: '/funder/manage/indicatorFrameworks/period-groups/:periodGroupId/periods',
    component: AsyncIndicatorFrameworkPeriodGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'PeriodGroups', path: '/funder/programmes/period-groups' },
    ],
    exact: true,
    path: '/funder/programmes/period-groups',
    component: AsyncIndicatorFrameworkPeriodGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'PeriodGroups', path: '/funder/programmes/period-groups' },
      { title: 'Periods', path: '/funder/programmes/period-groups/:periodGroupId/periods' },
    ],
    exact: true,
    path: '/funder/programmes/period-groups/:periodGroupId/periods',
    component: AsyncIndicatorFrameworkPeriodGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Interventions', path: '/funder/interventions' },
      { title: 'PeriodGroups', path: '/funder/interventions/period-groups' },
    ],
    exact: true,
    path: '/funder/interventions/period-groups',
    component: AsyncIndicatorFrameworkPeriodGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Interventions', path: '/funder/interventions' },
      { title: 'PeriodGroups', path: '/funder/interventions/period-groups' },
      { title: 'Periods', path: '/funder/interventions/period-groups/:periodGroupId/periods' },
    ],
    exact: true,
    path: '/funder/interventions/period-groups/:periodGroupId/periods',
    component: AsyncIndicatorFrameworkPeriodGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Interventions', path: '/funder/interventions' },
      { title: 'CurrencyGroups', path: '/funder/interventions/currency-groups' },
    ],
    exact: true,
    path: '/funder/interventions/currency-groups',
    component: AsyncIndicatorFrameworkCurrencyGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Interventions', path: '/funder/interventions' },
      { title: 'CurrencyGroups', path: '/funder/interventions/currency-groups' },
      { title: 'Periods', path: '/funder/interventions/currency-groups/:currencyGroupId/periods' },
    ],
    exact: true,
    path: '/funder/interventions/currency-groups/:currencyGroupId/periods',
    component: AsyncIndicatorFrameworkCurrencyGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'CurrencyGroups', path: '/funder/programmes/currency-groups' },
    ],
    exact: true,
    path: '/funder/programmes/currency-groups',
    component: AsyncIndicatorFrameworkCurrencyGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programmes', path: '/funder/programmes' },
      { title: 'CurrencyGroups', path: '/funder/programmes/currency-groups' },
      { title: 'Periods', path: '/funder/programmes/currency-groups/:currencyGroupId/periods' },
    ],
    exact: true,
    path: '/funder/programmes/currency-groups/:currencyGroupId/periods',
    component: AsyncIndicatorFrameworkCurrencyGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'IndicatorFrameworks', path: '/funder/manage/indicatorFrameworks' },
      { title: 'CurrencyGroups', path: '/funder/manage/indicatorFrameworks/currency-groups' },
    ],
    exact: true,
    path: '/funder/manage/indicatorFrameworks/currency-groups',
    component: AsyncIndicatorFrameworkCurrencyGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'IndicatorFrameworks', path: '/funder/manage/indicatorFrameworks' },
      { title: 'CurrencyGroups', path: '/funder/manage/indicatorFrameworks/currency-groups' },
      { title: 'Periods', path: '/funder/manage/indicatorFrameworks/currency-groups/:currencyGroupId/periods' },
    ],
    exact: true,
    path: '/funder/manage/indicatorFrameworks/currency-groups/:currencyGroupId/periods',
    component: AsyncIndicatorFrameworkCurrencyGroupPeriods,
  },
  // exports
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Data Exports', path: '/funder/exports' },
    ],
    exact: true,
    path: '/funder/exports',
    component: AsyncMetabaseDataExport,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Data Exports', path: '/funder/exports' },
      { title: 'Questions', path: '/funder/exports/:workspaceId/questions' },
    ],
    exact: true,
    path: '/funder/exports/:workspaceId/questions',
    component: AsyncMetabaseDataExport,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Data Exports', path: '/funder/exports' },
      { title: 'Questions', path: '/funder/exports/:workspaceId/questions' },
      { title: 'Question', path: '/funder/exports/:workspaceId/questions/:type/:typeId' },
    ],
    exact: true,
    path: '/funder/exports/:workspaceId/questions/:type/:typeId',
    component: AsyncMetabaseDataExportQuestion,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Profile Data', path: '/funder/exports/profile-data' },
    ],
    exact: true,
    path: '/funder/exports/profile-data',
    component: AsyncExport,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'School Data Exports', path: '/funder/exports/school-data-exports' },
    ],
    exact: true,
    path: '/funder/exports/school-data-exports',
    component: AsyncMetabaseDataExport,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Programme Stats', path: '/funder/exports/programme-stats' },
    ],
    exact: true,
    path: '/funder/exports/programme-stats',
    component: AsyncProgrammeStats,
  },

  // reports
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Reports', path: '/funder/reports' },
    ],
    exact: true,
    path: '/funder/reports',
    component: AsyncReports,
  },
  // IB-1899: periods owed by this organisation (Reports > Requirements)
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Reports', path: '/funder/reports' },
      { title: 'Requirements', path: '/funder/reports/requirements' },
    ],
    exact: true,
    path: '/funder/reports/requirements',
    component: AsyncReports,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Reports', path: '/funder/reports' },
      { title: 'Create', path: '/funder/reports/create' },
    ],
    exact: true,
    path: '/funder/reports/create',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Reports', path: '/funder/reports' },
      { title: 'Create', path: '/funder/reports/create-link' },
    ],
    exact: true,
    path: '/funder/reports/create-link',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Reports', path: '/funder/reports' },
      { title: 'Create', path: '/funder/reports/create-report' },
    ],
    exact: true,
    path: '/funder/reports/create-report',
    component: AsyncReportDetails,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Reports', path: '/funder/reports' },
      { title: 'Create', path: '/funder/reports/create-template' },
    ],
    exact: true,
    path: '/funder/reports/create-template',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Reports', path: '/funder/reports' },
      { title: 'Create', path: '/funder/reports/templates' },
    ],
    exact: true,
    path: '/funder/reports/templates',
    component: AsyncReports,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Reports', path: '/funder/reports' },
      { title: 'Create', path: '/funder/reports/templates/:templateId' },
    ],
    exact: true,
    path: '/funder/reports/templates/:templateId',
    component: AsyncReportDetails,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Reports', path: '/funder/reports' },
      { title: 'Edit', path: '/funder/reports/:reportId' },
    ],
    exact: true,
    path: '/funder/reports/:reportId',
    component: AsyncReportDetails,
  },
  // Insights
  // Manage Insights
  {
    breadcrumbs: [
      { title: 'Funder', path: '/funder' },
      {
        title: 'Insights',
        path: '/funder/manage/insights',
      },
    ],
    exact: true,
    path: '/funder/manage/insights',
    component: AsyncManageInsights,
  },
  // Create Insight
  {
    breadcrumbs: [
      { title: 'Funder', path: '/funder' },
      { title: 'Insight', path: '/funder/manage/insights' },
    ],
    exact: true,
    path: '/funder/manage/insights/create-new',
    component: AsyncInsightsDetails,
  },
  // Update Insight
  {
    breadcrumbs: [
      { title: 'Funder', path: '/funder' },
      { title: 'Insight', path: '/funder/manage/insights' },
    ],
    exact: true,
    path: '/funder/manage/insights/:insightId',
    component: AsyncInsightsDetails,
  },
  // Insight Users
  {
    breadcrumbs: [
      { title: 'Funder', path: '/funder' },
      { title: 'Insight', path: '/funder/manage/insights' },
      { title: 'Users', path: '/funder/manage/insights/:insightId/users' },
    ],
    exact: true,
    path: '/funder/manage/insights/:insightId/users',
    component: AsyncInsightUsers,
  },
  // Admin
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Admin', path: '/funder/admin' },
    ],
    exact: true,
    path: '/funder/admin',
    component: AsyncAdminPage,
  },
  // Account Details - a funder managing its own profile
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Admin', path: '/funder/admin' },
      { title: 'Account Details', path: '/funder/account' },
    ],
    exact: true,
    path: '/funder/account',
    component: AsyncAccountDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/admin/workspaces' },
    ],
    exact: true,
    path: '/funder/admin/workspaces',
    component: AllWorkspaces,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/admin/workspaces' },
      { title: 'Create', path: '/funder/admin/workspaces/create-new' },
    ],
    exact: true,
    path: '/funder/admin/workspaces/create-new',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/admin/workspaces' },
      { title: 'Edit', path: '/funder/admin/workspaces/:workspaceId' },
    ],
    exact: true,
    path: '/funder/admin/workspaces/:workspaceId',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/admin/workspaces' },
      { title: 'Overview', path: '/funder/admin/workspaces/:workspaceId/overview' },
    ],
    exact: true,
    path: '/funder/admin/workspaces/:workspaceId/overview',
    component: AsyncAdminWorkspaceOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/admin/workspaces' },
      { title: 'Dataset', path: '/funder/admin/workspaces/:workspaceId/overview/datasets/create-new' },
    ],
    exact: true,
    path: '/funder/admin/workspaces/:workspaceId/overview/datasets/create-new',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/admin/workspaces' },
      { title: 'Dataset', path: '/funder/admin/workspaces/:workspaceId/overview/datasets/:datasetId' },
    ],
    exact: true,
    path: '/funder/admin/workspaces/:workspaceId/overview/datasets/:datasetId',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/admin/workspaces' },
      { title: 'Form', path: '/funder/admin/workspaces/:workspaceId/overview/forms/create-new' },
    ],
    exact: true,
    path: '/funder/admin/workspaces/:workspaceId/overview/forms/create-new',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/admin/workspaces' },
      { title: 'Form', path: '/funder/admin/workspaces/:workspaceId/overview/forms/:formId' },
    ],
    exact: true,
    path: '/funder/admin/workspaces/:workspaceId/overview/forms/:formId',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Templates', path: '/funder/admin/templates' },
    ],
    exact: true,
    path: '/funder/admin/templates',
    component: AllWorkspaces,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Modules', path: '/funder/admin/modules' },
    ],
    exact: true,
    path: '/funder/admin/modules',
    component: AsyncAdminModules,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Audit Trail', path: '/funder/admin/audittrail' },
    ],
    exact: true,
    path: '/funder/admin/audittrail',
    component: AsyncAdminAuditTrail,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Organisations', path: '/funder/admin/organisations' },
    ],
    exact: true,
    path: '/funder/admin/organisations',
    component: AsyncAdminOrganisations,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Organisations', path: '/funder/admin/organisations' },
      { title: 'Users', path: '/funder/admin/organisations/:organisationId/users' },
    ],
    exact: true,
    path: '/funder/admin/organisations/:organisationId/users',
    component: AsyncAdminOrganisationsUsers,
  },
  // institutions
  // management
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
    ],
    exact: true,
    path: '/funder/manage/institutions',
    component: AsyncInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Sites', path: '/funder/manage/institutions/sites' },
    ],
    exact: true,
    path: '/funder/manage/institutions/sites',
    component: AsyncInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Sites', path: '/funder/manage/institutions/sites' },
      { title: 'Hierarchies', path: '/funder/manage/institutions/sites/hierarchies' },
    ],
    exact: true,
    path: '/funder/manage/institutions/sites/hierarchies',
    component: AsyncProgrammeHierarchies,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Sites', path: '/funder/manage/institutions/sites' },
      { title: 'Hierarchies', path: '/funder/manage/institutions/sites/hierarchies' },
      { title: 'Hierarchy', path: '/funder/manage/institutions/sites/hierarchies/:hierarchyId' },
    ],
    exact: true,
    path: '/funder/manage/institutions/sites/hierarchies/:hierarchyId',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Sites', path: '/funder/manage/institutions/sites' },
      { title: 'Hierarchies', path: '/funder/manage/institutions/sites/hierarchies' },
      { title: 'Create', path: '/funder/manage/institutions/sites/hierarchies/create' },
    ],
    exact: true,
    path: '/funder/manage/institutions/sites/hierarchies/create',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Sites', path: '/funder/manage/institutions/sites' },
      { title: 'Services', path: '/funder/manage/institutions/sites/services' },
    ],
    exact: true,
    path: '/funder/manage/institutions/sites/services',
    component: AsyncProgrammeServices,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Sites', path: '/funder/manage/institutions/sites' },
      { title: 'Services', path: '/funder/manage/institutions/sites/services' },
      { title: 'Service', path: '/funder/manage/institutions/sites/services/:serviceId' },
    ],
    exact: true,
    path: '/funder/manage/institutions/sites/services/:serviceId',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Sites', path: '/funder/manage/institutions/sites' },
      { title: 'Services', path: '/funder/manage/institutions/sites/services' },
      { title: 'Create', path: '/funder/manage/institutions/sites/services/create' },
    ],
    exact: true,
    path: '/funder/manage/institutions/sites/services/create',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Cohorts', path: '/funder/manage/institutions/cohorts' },
    ],
    exact: true,
    path: '/funder/manage/institutions/cohorts',
    component: AsyncInstitutionCohorts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Registrations', path: '/funder/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations',
    component: AsyncInstitutionRegistrations,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Registrations', path: '/funder/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/archived',
    component: AsyncArchivedInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Registrations', path: '/funder/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/create',
    component: AsyncInstitutionDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Registrations', path: '/funder/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/:institutionId',
    component: AsyncInstitutionDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Registrations', path: '/funder/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/:institutionId/service-details', // only for ECD Services
    component: AsyncECDServiceDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Registrations', path: '/funder/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/:institutionId/service-contacts', // only for ECD Services
    component: AsyncECDServiceContacts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Registrations', path: '/funder/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/:institutionId/registration-management', // only for ECD Services
    component: AsyncECDServiceRegistrationManagement,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Registrations', path: '/funder/manage/institutions/registrations' },
      {
        title: 'ECD Registrations',
        path: '/funder/manage/institutions/registrations/:institutionId/registrations',
      },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/:institutionId/registrations',
    component: AsyncECDRegistrations,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'ECD Registrations', path: '/funder/manage/institutions/registrations' },
      {
        title: 'Registration Progress',
        path: '/funder/manage/institutions/registrations/:institutionId/registrations',
      },
      {
        title: 'New Registration',
        path: '/funder/manage/institutions/registrations/:institutionId/registrations/register',
      },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/:institutionId/registrations/register',
    component: AsyncECDApplication,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'ECD Registrations', path: '/funder/manage/institutions/registrations' },
      {
        title: 'Application',
        path: '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/application',
      },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/application',
    component: AsyncECDApplication,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'ECD Registrations', path: '/funder/manage/institutions/registrations' },
      {
        title: 'Framework',
        path: '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/framework',
      },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/framework',
    component: AsyncECDFramework,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'ECD Registrations', path: '/funder/manage/institutions/registrations' },
      {
        title: 'Assessment',
        path: '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/assessment',
      },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/assessment',
    component: AsyncECDAssessment,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'ECD Registrations', path: '/funder/manage/institutions/registrations' },
      {
        title: 'Complete',
        path: '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/complete',
      },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/complete',
    component: AsyncECDComplete,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Registrations', path: '/funder/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/approve',
    component: AsyncECDApproval,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Create', path: '/funder/manage/institutions/create' },
    ],
    exact: true,
    path: '/funder/manage/institutions/create',
    component: AsyncInstitutionDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Edit', path: '/funder/manage/institutions/:institutionId' },
    ],
    exact: true,
    path: '/funder/manage/institutions/:institutionId',
    component: AsyncInstitutionDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Cohorts', path: '/funder/manage/institutions/cohorts' },
      { title: 'Create', path: '/funder/manage/institutions/cohorts/create' },
    ],
    exact: true,
    path: '/funder/manage/institutions/cohorts/create',
    component: AsyncInstitutionCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Institutions', path: '/funder/manage/institutions' },
      { title: 'Cohorts', path: '/funder/manage/institutions/cohorts' },
      { title: 'Edit', path: '/funder/manage/institutions/cohorts/:cohortId' },
    ],
    exact: true,
    path: '/funder/manage/institutions/cohorts/:cohortId',
    component: AsyncInstitutionCohortDetails,
  },
  // my activities
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'My Activities', path: '/funder/my-activities' },
    ],
    exact: true,
    path: '/funder/my-activities',
    component: AsyncActivitiesDetails,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/my-activities' },
      { title: 'Attendees', path: '/funder/activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/funder/activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/my-activities' },
      { title: 'Attendees', path: '/funder/my-activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/funder/my-activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/my-activities' },
      { title: 'Sessions', path: '/funder/my-activities/:activityId/sessions/' },
    ],
    exact: true,
    path: '/funder/my-activities/:activityId/sessions/',
    component: AsyncActivitiesSessions,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/my-activities' },
      { title: 'Sessions', path: '/funder/my-activities/:activityId/sessions/' },
      { title: 'Create Session', path: '/funder/my-activities/:activityId/sessions/create' },
    ],
    exact: true,
    path: '/funder/my-activities/:activityId/sessions/create',
    component: AsyncActivitiesSessionsCreate,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/my-activities' },
      { title: 'Sessions', path: '/funder/my-activities/:activityId/sessions/' },
      { title: 'Update Session', path: '/funder/my-activities/:activityId/sessions/:sessionId' },
    ],
    exact: true,
    path: '/funder/my-activities/:activityId/sessions/:sessionId',
    component: AsyncActivitiesSessionsCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Activities', path: '/funder/activities' },
      { title: 'Activity', path: '/funder/activities/activity/:activityId' },
    ],
    exact: true,
    path: '/funder/activities/activity/:activityId',
    component: AsyncActivitiesAttendees,
  },

  // My Forms
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'My Forms', path: '/funder/my-forms' },
    ],
    exact: true,
    path: '/funder/my-forms',
    component: AsyncMyFormsPage,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'My Forms', path: '/funder/my-forms' },
      { title: 'Submissions', path: '/funder/my-forms/:id/submissions' },
    ],
    exact: true,
    path: '/funder/my-forms/:id/submissions',
    component: AsyncMyFormsPage,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'My Forms', path: '/my-forms' },
      { title: 'Submissions', path: '/my-forms/:id/submissions' },
    ],
    exact: true,
    path: '/my-forms/:id/submissions',
    component: AsyncMyFormsPage,
  },
  //submission

  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'My Forms', path: '/my-forms' },
      { title: 'Submissions', path: '/my-forms/:id/submissions/submit' },
    ],
    exact: true,
    path: '/my-forms/:id/submissions/submit',
    component: AsyncMyFormsCreateSubmission,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'My Forms', path: '/funder/my-forms' },
      { title: 'Submissions', path: '/funder/my-forms/:id/submissions/submit' },
    ],
    exact: true,
    path: '/funder/my-forms/:id/submissions/submit',
    component: AsyncMyFormsCreateSubmission,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'My Forms', path: '/funder/my-forms' },
      { title: 'Submissions', path: '/funder/my-forms/:id/submissions/:submissionId' },
    ],
    exact: true,
    path: '/funder/my-forms/:id/submissions/:submissionId',
    component: AsyncMyFormsSubmissionPage,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'My Forms', path: '/funder/my-forms' },
      { title: 'Calculate', path: '/funder/my-forms/:id/submissions/:submissionId/calculate' },
    ],
    exact: true,
    path: '/funder/my-forms/:id/submissions/:submissionId/calculate',
    component: AsyncMyFormsSubmissionCalculate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'My Forms', path: '/funder/my-forms' },
      { title: 'Calculate', path: '/funder/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber' },
    ],
    exact: true,
    path: '/funder/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber',
    component: AsyncMyFormsSubmissionCalculate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'My Forms', path: '/my-forms' },
      { title: 'Submissions', path: '/my-forms/:id/submissions/:submissionId' },
    ],
    exact: true,
    path: '/my-forms/:id/submissions/:submissionId',
    component: AsyncMyFormsSubmissionPage,
  },

  // {
  //   breadcrumbs: [{ title: 'Home', path: '/funder' }, { title: 'Forms', path: '/funder/manage/my-forms' }],
  //   exact: true,
  //   path: '/funder/manage/my-forms',
  //   component: AsyncMyFormsPage,
  // },
  // {
  //   breadcrumbs: [
  //     { title: 'Home', path: '/funder' },
  //     { title: 'Forms', path: '/funder/manage/my-forms' },
  //     { title: 'Submissions', path: '/funder/manage/my-forms/:id/submissions' },
  //   ],
  //   exact: true,
  //   path: '/funder/manage/my-forms/:id/submissions',
  //   component: AsyncMyFormsPage,
  // },
  // //submission
  // {
  //   breadcrumbs: [
  //     { title: 'Home', path: '/funder' },
  //     { title: 'Forms', path: '/funder/manage/my-forms' },
  //     { title: 'Submissions', path: '/funder/manage/my-forms/:id/submissions' },
  //   ],
  //   exact: true,
  //   path: '/funder/manage/my-forms/:id/submissions/:submissionId',
  //   component: AsyncMyFormsSubmissionPage,
  // },

  // notifications
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Notifications', path: '/funder/notifications' },
    ],
    exact: true,
    path: '/funder/notifications',
    component: AsyncNotifications,
  },
  // dashboard
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Dashboards', path: '/funder/manage/dashboards' },
    ],
    exact: true,
    path: '/funder/manage/dashboards',
    component: AsyncDashboards,
  },
  // IB-1899 Reporting requirements
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Reporting Requirements', path: '/funder/manage/reporting-requirements' },
    ],
    exact: true,
    path: '/funder/manage/reporting-requirements',
    component: AsyncReportingRequirements,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Reporting Requirements', path: '/funder/manage/reporting-requirements' },
      { title: 'Requirement', path: '/funder/manage/reporting-requirements/:requirementId' },
    ],
    exact: true,
    path: '/funder/manage/reporting-requirements/:requirementId',
    component: AsyncReportingRequirementDetail,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Dashboards', path: '/funder/manage/dashboards' },
      { title: 'Workspace', path: '/funder/manage/dashboards/workspace/:workspaceId' },
    ],
    exact: true,
    path: '/funder/manage/dashboards/workspace/:workspaceId',
    component: AsyncDashboards,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Dashboards', path: '/funder/manage/dashboards' },
      { title: 'Workspace', path: '/funder/manage/dashboards/workspace/:workspaceId' },
      { title: 'Dashboard', path: '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId' },
    ],
    exact: true,
    path: '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId',
    component: AsyncDashboardsDashboard,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Dashboards', path: '/funder/manage/dashboards' },
      { title: 'Workspace', path: '/funder/manage/dashboards/workspace/:workspaceId' },
      { title: 'Users', path: '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId/users' },
    ],
    exact: true,
    path: '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId/users',
    component: AsyncDashboardsUsers,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Dashboards', path: '/funder/manage/dashboards' },
      { title: 'Metabase', path: '/funder/manage/dashboards/metabase' },
    ],
    exact: true,
    path: '/funder/manage/dashboards/metabase',
    component: AsyncDashboardsMetabase,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Dashboards', path: '/funder/manage/dashboards' },
      { title: 'Metabase', path: '/funder/manage/dashboards/metabase/:type/:id' },
    ],
    exact: true,
    path: '/funder/manage/dashboards/metabase/:type/:id',
    component: AsyncDashboardsMetabase,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Dashboards', path: '/funder/manage/dashboards' },
      { title: 'Create', path: '/funder/manage/dashboards/layout/create-new' },
    ],
    exact: true,
    path: '/funder/manage/dashboards/layout/create-new',
    component: AsyncNewDashboardLayout,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Dashboards', path: '/funder/manage/dashboards' },
      { title: 'Edit', path: '/funder/manage/dashboards/layout/:layoutId' },
    ],
    exact: true,
    path: '/funder/manage/dashboards/layout/:layoutId',
    component: AsyncNewDashboardLayout,
  },

  //Manage Forms

  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/manage/workspaces' },
    ],
    exact: true,
    path: '/funder/manage/workspaces',
    component: AllWorkspaces,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/manage/workspaces' },
      { title: 'Create', path: '/funder/manage/workspaces/create-new' },
    ],
    exact: true,
    path: '/funder/manage/workspaces/create-new',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/manage/workspaces' },
      { title: 'Edit', path: '/funder/manage/workspaces/:workspaceId' },
    ],
    exact: true,
    path: '/funder/manage/workspaces/:workspaceId',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/manage/workspaces' },
      { title: 'Overview', path: '/funder/manage/workspaces/:workspaceId/overview' },
    ],
    exact: true,
    path: '/funder/manage/workspaces/:workspaceId/overview',
    component: AsyncAdminWorkspaceOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/manage/workspaces' },
      { title: 'Dataset', path: '/funder/manage/workspaces/:workspaceId/overview/datasets/create-new' },
    ],
    exact: true,
    path: '/funder/manage/workspaces/:workspaceId/overview/datasets/create-new',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/manage/workspaces' },
      { title: 'Dataset', path: '/funder/manage/workspaces/:workspaceId/overview/datasets/:datasetId' },
    ],
    exact: true,
    path: '/funder/manage/workspaces/:workspaceId/overview/datasets/:datasetId',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/manage/workspaces' },
      { title: 'Form', path: '/funder/manage/workspaces/:workspaceId/overview/forms/create-new' },
    ],
    exact: true,
    path: '/funder/manage/workspaces/:workspaceId/overview/forms/create-new',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Workspaces', path: '/funder/manage/workspaces' },
      { title: 'Form', path: '/funder/manage/workspaces/:workspaceId/overview/forms/:formId' },
    ],
    exact: true,
    path: '/funder/manage/workspaces/:workspaceId/overview/forms/:formId',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Cases', path: '/funder/manage/cases' },
      { title: 'Appointments', path: '/funder/manage/cases/appointments' },
    ],
    exact: true,
    path: '/funder/manage/cases/appointments',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Cases', path: '/funder/manage/cases' },
    ],
    exact: true,
    path: '/funder/manage/cases',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Cases', path: '/funder/manage/cases' },
      { title: 'Consultations', path: '/funder/manage/cases/consultations' },
    ],
    exact: true,
    path: '/funder/manage/cases/consultations',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Cases', path: '/funder/manage/cases' },
      { title: 'Medication Queue', path: '/funder/manage/cases/medication-queue' },
    ],
    exact: true,
    path: '/funder/manage/cases/medication-queue',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Cases', path: '/funder/manage/cases' },
      { title: 'Case Management', path: '/funder/manage/cases/case-management' },
    ],
    exact: true,
    path: '/funder/manage/cases/case-management',
    component: AsyncCaseManagement,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Cases', path: '/funder/manage/cases' },
      { title: 'Case Management', path: '/funder/manage/cases/case-management' },
      { title: 'Configure', path: '/funder/manage/cases/case-management/activities/:activityId/configure' },
    ],
    exact: true,
    path: '/funder/manage/cases/case-management/activities/:activityId/configure',
    component: AsyncConfigureSession,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Cases', path: '/funder/manage/cases' },
      { title: 'Consultations', path: '/funder/manage/cases/consultations' },
      { title: 'Consultation', path: '/funder/manage/cases/consultations/:consultationId' },
    ],
    exact: true,
    path: '/funder/manage/cases/consultations/:consultationId',
    component: AsyncConsultationPage,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/funder' },
      { title: 'Cases', path: '/funder/manage/cases' },
      { title: 'Case', path: '/funder/manage/cases/:caseId' },
    ],
    exact: true,
    path: '/funder/manage/cases/:caseId',
    component: AsyncClientPage,
  },
];
